/**
 * Module summary:
 * This is the browser entry point. It initializes Firebase auth persistence
 * when needed, mounts the React app, and wraps routing around the root app
 * component.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { initializeFirebaseAuth } from './services/firebaseConfig';
import './index.css'; // <--- ADD THIS LINE (Must be index.css, not App.css)

const USE_FIREBASE = (process.env.REACT_APP_DATA_PROVIDER || 'firebase') === 'firebase';

if (USE_FIREBASE) {
  // Initialize auth persistence before the app starts reading session state so
  // refreshes restore the expected Firebase session.
  void initializeFirebaseAuth().catch((err) => {
    console.error('Failed to initialize Firebase auth persistence:', err);
  });
}

const root = ReactDOM.createRoot(
  // Attach React to the root DOM node created in public/index.html.
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
